import type React from "react";
import { View } from "tamagui";

export const Separator: React.FC<{ noMargins?: boolean }> = ({ noMargins }) => {
  return (
    <View
      flex={1}
      backgroundColor={"$divider"}
      maxHeight={1}
      height={1}
      marginVertical={noMargins ? undefined : "$space.medium"}
    />
  );
};
